var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5594 17.5981C16.2758 17.5138 16.0759 17.3208 15.8796 17.1208C14.6764 15.9067 13.4659 14.696 12.259 13.4853C12.2191 13.4432 12.1827 13.3976 12.1427 13.352C10.3397 14.503 8.40945 14.8258 6.34834 14.2328C4.82159 13.7942 3.61109 12.9098 2.72776 11.629C0.826594 8.86381 1.37913 5.23186 4.03277 3.10181C6.55554 1.07704 10.118 1.11915 12.5826 3.12287C13.9857 4.26334 14.7927 5.72664 14.9527 7.49876C15.1126 9.26736 14.5746 10.8359 13.4186 12.2185C13.495 12.2957 13.5677 12.3729 13.644 12.4466C14.8618 13.6678 16.0795 14.8925 17.2973 16.1137C17.6754 16.4962 17.7081 17.0015 17.3482 17.3384C17.2246 17.4577 17.0392 17.5173 16.8829 17.6016C16.7739 17.5981 16.6684 17.5981 16.5594 17.5981ZM8.29676 3.29481C5.57769 3.2913 3.36027 5.42837 3.353 8.06022C3.34573 10.6886 5.5886 12.8502 8.3004 12.8362C11.034 12.8186 13.2369 10.6886 13.2333 8.06373C13.2296 5.43188 11.0158 3.29481 8.29676 3.29481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f39709d18a1897cff7b8a2f47685824a.svg";
export { ForwardRef as ReactComponent };